module.exports = __webpack_public_path__ + "static/media/settings-4.4db4cdd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/settings-4.svg
// module id = 3363
// module chunks = 6